import { render, staticRenderFns } from "./ConsentGroupDetail.vue?vue&type=template&id=53640308&scoped=true&"
import script from "./ConsentGroupDetail.vue?vue&type=script&lang=js&"
export * from "./ConsentGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsentGroupDetail.vue?vue&type=style&index=0&id=53640308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53640308",
  null
  
)

export default component.exports